import { axiosClient } from "../axios";
import { getQuery } from "../helper";

export function getSbus(options = { type: "active", "manager-id": null }) {
  const query = getQuery(options);
  return axiosClient.get("rtm/sbus", query);
}
